import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface IMembers {
member_id:number,
member_name:string,
mobile_number:string,
age:number,
blood_group_id:number,
desig_level_id:number,
designation_id:number,
address:string,
pincode:string,
vibhag_id:number,
zill_id:number,
nagar_khanda_id:number,
login_otp:number,
last_logged_in:Date,
is_active:boolean,
created_on:Date,
modified_on:Date
}

interface IMembersData {
    list?: Array<IMembers>;
    pageNo: number;
    pageSize: number;
    searchKey?: string;
    totalCount?: number;
    message?: string;
}

const initialState: IMembersData = {
    pageNo: 1,
    pageSize: 20,
    searchKey: '',
    list: [],
    totalCount: 0,
    message: '',
};

const membersSlice = createSlice({
    name: "members",
    initialState,
    reducers: {
        setMembersList: (state, _action: PayloadAction<IMembersData>) => {
            state.list = _action.payload.list;
            state.pageNo = _action.payload.pageNo;
            state.pageSize = _action.payload.pageSize;
            state.totalCount = _action.payload.totalCount;
        },
        resetMembersToInit: (state) => {
            state = initialState;
        },
        setMembersMessage: (state, _action: PayloadAction<string>) => {
            state.message = _action.payload;
        },
    },
});

export const { setMembersList, resetMembersToInit, setMembersMessage } = membersSlice.actions;

export default membersSlice.reducer;

